(function () {
  var drawer = document.querySelector('[data-em-drawer]');
  var opener = document.querySelector('[data-em-open]');
  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var close = drawer.querySelector('[data-em-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
  }
  if (opener) opener.addEventListener('click', openDrawer);
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('[data-em-close]')) closeDrawer();
    });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  var filters = document.querySelector('[data-em-filters]');
  if (filters && window.matchMedia('(max-width: 989px)').matches) filters.removeAttribute('open');

  var sort = document.querySelector('[data-em-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();

/* product page */
(function () {
  var root = document.querySelector('[data-em-product]');
  if (!root) return;
  var dataEl = document.querySelector('[data-em-variants]');
  var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
  var idInput = root.querySelector('[data-em-variant]');
  var addBtn = root.querySelector('[data-em-add]');
  var priceEl = root.querySelector('[data-em-price]');
  var mainImg = root.querySelector('.em-gallery__main img');
  var money = function (cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  function showImage(src) {
    if (!mainImg || !src) return;
    mainImg.removeAttribute('srcset');
    mainImg.src = src;
  }
  root.querySelectorAll('[data-em-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      showImage(b.getAttribute('data-em-thumb'));
      root.querySelectorAll('.em-thumb').forEach(function (x) { x.classList.remove('is-on'); });
      b.classList.add('is-on');
    });
  });
  function selected() {
    var vals = [];
    root.querySelectorAll('[data-em-opt]:checked').forEach(function (i) { vals[+i.getAttribute('data-em-opt')] = i.value; });
    return vals;
  }
  function matches(x, vals) {
    return x.options.every(function (o, i) { return vals[i] === undefined || o === vals[i]; });
  }
  // grey out choices that have no in-stock variant with the other current choices
  function markAvailability(vals) {
    root.querySelectorAll('[data-em-opt]').forEach(function (input) {
      var test = vals.slice();
      test[+input.getAttribute('data-em-opt')] = input.value;
      var ok = variants.some(function (x) { return x.available && matches(x, test); });
      input.parentNode.classList.toggle('is-na', !ok);
    });
  }
  function update() {
    var vals = selected();
    var v = variants.find(function (x) { return matches(x, vals); });
    markAvailability(vals);
    vals.forEach(function (val, i) {
      var lbl = root.querySelector('[data-em-optval="' + i + '"]');
      if (lbl) lbl.textContent = String(val).replace('Twin Long', 'Twin XL');
    });
    if (!v) {
      addBtn.disabled = true; addBtn.textContent = 'Unavailable';
      return;
    }
    idInput.value = v.id;
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    var sale = v.compare_at_price && v.compare_at_price > v.price;
    priceEl.innerHTML = '<span class="em-buy__now' + (sale ? ' em-price--sale' : '') + '">' + money(v.price) + '</span>' +
      (sale ? '<s>' + money(v.compare_at_price) + '</s><span class="em-save">Save ' + money(v.compare_at_price - v.price) + '</span>' : '');
    if (v.featured_image) {
      var src = v.featured_image.src;
      showImage(src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200');
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  }
  root.querySelectorAll('[data-em-opt]').forEach(function (i) { i.addEventListener('change', update); });
  if (variants.length > 1) markAvailability(selected());
  root.querySelectorAll('[data-em-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = root.querySelector('input[name="quantity"]');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-em-qty'), 10));
    });
  });
})();

/* FAQ accordion: bold question lines become expandable items */
(function () {
  var box = document.querySelector('[data-em-faq]');
  if (!box) return;
  var nodes = Array.prototype.slice.call(box.children);
  function isQ(el) {
    if (el.tagName !== 'P' && !/^H[2-4]$/.test(el.tagName)) return false;
    var t = el.textContent.trim();
    var strong = el.querySelector('strong,b');
    return t.length > 0 && t.length < 140 && (/^H[2-4]$/.test(el.tagName) || (strong && strong.textContent.trim().length >= t.length - 2));
  }
  if (nodes.filter(isQ).length < 2) return;
  var out = document.createElement('div');
  out.className = 'em-faq';
  var intro = document.createElement('div');
  var current = null, count = 0;
  nodes.forEach(function (el) {
    if (isQ(el)) {
      var d = document.createElement('details');
      var s = document.createElement('summary');
      s.textContent = el.textContent.trim().replace(/[:\s]+$/, '');
      var a = document.createElement('div');
      a.className = 'em-faq__a';
      d.appendChild(s); d.appendChild(a);
      out.appendChild(d);
      current = a; count++;
    } else if (current) {
      current.appendChild(el);
    } else {
      intro.appendChild(el);
    }
  });
  if (count < 2) return;
  box.innerHTML = '';
  if (intro.children.length) box.appendChild(intro);
  box.appendChild(out);
  var firstQ = out.querySelector('details');
  if (firstQ) firstQ.open = true;
  // a final "we'll add more" style line ends up as an empty-answer question; show it as plain text instead
  out.querySelectorAll('details').forEach(function (d) {
    var a = d.querySelector('.em-faq__a');
    // answers written as "A: ..." read oddly under an open question, so drop the prefix
    var fp = a.querySelector('p');
    if (fp && /^\s*A:\s*/.test(fp.textContent)) fp.innerHTML = fp.innerHTML.replace(/^\s*A:\s*/, '');
    if (!a.textContent.trim()) {
      var p = document.createElement('p');
      p.className = 'em-muted';
      p.textContent = d.querySelector('summary').textContent;
      d.replaceWith(p);
    }
  });
})();
